import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormSelectChoice, FormFieldComponentProps, VerificationServiceProps, StudentPersonalInfoViewModel, Country } from '../../../lib/types/types';
import { TypeaheadComponent } from '../../FormInputs/Typeahead/TypeaheadComponent';
import { getSafe } from '../../../lib/utils/objects';

const CollegeNameComponent = ({
    onChange,
    value,
    isErrored,
    verificationService,
    placeholder = '',
}: FormFieldComponentProps & VerificationServiceProps) => {
    const programId = verificationService.programId;

    return (
        <div className="sid-field sid-college-name-id">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-college-name">
                <div className={`sid-field__label sid-field__label--required sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <FormattedHTMLMessage
                        id="schoolName"
                        defaultMessage="University / College name"
                    />
                </div>
            </label>

            <TypeaheadComponent
                className={isErrored ? 'sid-text-input--error' : ''}
                countryCode={getSafe<Country>(() => verificationService.viewModel.countryChoice.value)}
                minimumSearchValueLength={3}
                onChange={ (choice: FormSelectChoice) => onChange(choice) }
                placeholder={placeholder}
                programId={programId}
                value={value}
                inputHtmlId="sid-college-name"
                openOrgSearchEnabled={verificationService.programTheme.openOrgSearchEnabled}
                orgSearchUrl={verificationService.programTheme.config.orgSearchUrl}
            />
            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidOrganization"
                            defaultMessage="You must select an organization from the list"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export {  CollegeNameComponent };
